import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import ChatBot from "../chatbot/ChatBot";

const DESKTOP_VIEWPORT = "width=1280";
const MOBILE_VIEWPORT = "width=device-width, initial-scale=1";
const MOBILE_VIEWPORT_CLASS = "is-native-mobile-viewport";

function getViewportMeta() {
  let viewportMeta = document.querySelector('meta[name="viewport"]');

  if (!viewportMeta) {
    viewportMeta = document.createElement("meta");
    viewportMeta.setAttribute("name", "viewport");
    document.head.appendChild(viewportMeta);
  }

  return viewportMeta;
}

export default function MainLayout() {
  const { pathname } = useLocation();
  const isLogin = pathname === "/";
  const isPrintRoute = pathname.startsWith("/print/");
  const isEggUsageMobileRoute = pathname.startsWith("/orders/egg-usage-mobile");
  const isInstructionCompletionMobileRoute = pathname.includes("/instruction-completion/mobile");
  const isStocktakingMobileRoute = pathname.startsWith("/stocktaking/mobile");
  const isInventoryHistoryRoute = (
    pathname.startsWith("/inventory/")
    && pathname.endsWith("/history")
  );
  const shouldUseNativeMobileViewport = (
    isEggUsageMobileRoute
    || isInstructionCompletionMobileRoute
    || isStocktakingMobileRoute
    || isInventoryHistoryRoute
  );
  const shouldHideChrome = (
    isLogin
    || isPrintRoute
    || isEggUsageMobileRoute
    || isInstructionCompletionMobileRoute
    || isStocktakingMobileRoute
  );

  useEffect(() => {
    const viewportMeta = getViewportMeta();

    viewportMeta.setAttribute(
      "content",
      shouldUseNativeMobileViewport ? MOBILE_VIEWPORT : DESKTOP_VIEWPORT
    );
    document.documentElement.classList.toggle(
      MOBILE_VIEWPORT_CLASS,
      shouldUseNativeMobileViewport
    );
  }, [shouldUseNativeMobileViewport]);

  return (
    <div>
      {!shouldHideChrome && <Navbar />}
      <Outlet />
      {!shouldHideChrome && <ChatBot pagePath={pathname} />}
    </div>
  );
}
